export default __webpack_public_path__ + "static/media/gallery.cb6a58c7.svg";